import { z } from 'zod';
import { FlowCustomSubtaskBlockConfigSchema, FlowHumanTaskDynamicConfigBlockConfigSchema, FlowSubmitPriorAuthorizationBlockConfigSchema, } from './config.js';
const DocumentMetadataResponseSchema = z.object({
    id: z.string(),
    date: z.string(),
    type: z.string(),
    title: z.string(),
    summary: z.string().optional(),
    source: z.string(),
    // Allowing string rawJson to be backwards compatible with previously extracted documents
    rawJson: z.union([z.string(), z.record(z.string(), z.unknown())]).nullable(),
});
export const FlowHumanTaskDocumentTranscriptionResponsesSchema = z
    .array(z.object({
    documentId: z.string(),
    text: z.string().optional(),
    formattedText: z.string().optional(),
    error: z.string().optional(),
    metadata: DocumentMetadataResponseSchema.optional(),
}))
    .nullable();
export const FlowHumanTaskAdditionalContextSchema = z
    .object({
    payorPlanNameSelectValue: z.string().nullish(),
    physicianFaxNumber: z.string().nullish(),
    requestingPhysicianName: z.string().nullish(),
})
    .nullable();
export const FhirCodingSchema = z.object({
    system: z.string().nullish(),
    code: z.string().nullish(),
});
export const FhirObservationComponentSchema = z.object({
    value: z.string().nullish(),
    codings: z.array(FhirCodingSchema).nullish(),
});
export const FhirObservationReferenceRangeSchema = z.object({
    low: z.number().nullish(),
    high: z.number().nullish(),
    text: z.string().nullish(),
});
export const FhirLabValueSchema = z
    .object({
    id: z.string(),
    loinc: z.string().nullish(),
    date: z.string().nullish(),
    notes: z.string().nullish(),
    value: z.string(),
    testName: z.string().nullish(),
    components: z.array(FhirObservationComponentSchema).nullish(),
    encounter_id: z.string().nullish(),
    encounterTypes: z.array(z.string()).nullish(),
    referenceRanges: z.array(FhirObservationReferenceRangeSchema).nullish(),
})
    .nullable();
export const FhirLabValuesSchema = z.array(FhirLabValueSchema);
export const FlowHumanTaskCopilotDataContextObjectSchema = z
    .object({
    documents: FlowHumanTaskDocumentTranscriptionResponsesSchema.optional(),
    labValues: FhirLabValuesSchema.optional(),
    relevantDocumentIds: z.array(z.string()).nullish(),
    additionalContext: FlowHumanTaskAdditionalContextSchema.optional().nullable(),
})
    .nullable();
export const FlowSubmitPriorAuthorizationParsedConfigSchema = FlowSubmitPriorAuthorizationBlockConfigSchema.extend({
    priorAuthorizationInformation: FlowSubmitPriorAuthorizationBlockConfigSchema.shape.priorAuthorizationInformation.extend({
        copilotDataContext: FlowHumanTaskDocumentTranscriptionResponsesSchema,
        copilotDataContextObject: FlowHumanTaskCopilotDataContextObjectSchema.optional(),
        predictionOptions: z
            .object({
            preamble: z.string().optional(),
            outputRequirement: z.string().optional(),
            outro: z.string().optional(),
        })
            .optional(),
    }),
});
export const FlowHumanTaskParsedClinicalQuestionAssistantConfigSchema = z.object({
    dataContext: FlowHumanTaskCopilotDataContextObjectSchema,
});
export const FlowHumanTaskParsedDocumentPacketGeneratorConfigSchema = z.object({
    relevantDocuments: FlowHumanTaskDocumentTranscriptionResponsesSchema,
});
export const FlowHumanTaskParsedToolsSchema = z
    .object({
    enabledTools: z.array(z.string()).optional(),
    config: z
        .object({
        clinicalQuestionAssistant: FlowHumanTaskParsedClinicalQuestionAssistantConfigSchema.optional(),
        documentPacketGenerator: FlowHumanTaskParsedDocumentPacketGeneratorConfigSchema.optional(),
    })
        .optional(),
})
    .optional();
export const FlowCustomSubtaskParsedConfigSchema = FlowCustomSubtaskBlockConfigSchema.extend({
    tools: FlowHumanTaskParsedToolsSchema,
});
export const FlowHumanTaskDynamicConfigParsedConfigSchema = FlowHumanTaskDynamicConfigBlockConfigSchema.extend({
    tools: FlowHumanTaskParsedToolsSchema,
});
//# sourceMappingURL=parsedConfig.js.map